<!-- Backdrop -->
<div class="tp-modal-backdrop" *ngIf="isOpen" (click)="onClose()"></div>

<!-- Modal -->
<div class="tp-modal" *ngIf="isOpen" role="dialog" aria-modal="true">
  <div class="tp-modal-card" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="tp-modal-header">
      <div class="title">
        <i class="bi bi-box-seam"></i>
        <span>اختيار منتجات</span>
      </div>

      <button class="icon-btn" type="button" (click)="onClose()" aria-label="Close">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <!-- Body -->
    <div class="tp-modal-body">

      <!-- Search -->
      <div class="search-wrapper">
        <form (submit)="$event.preventDefault()" class="search-form">
          <div class="search-input-wrapper">
            <input
                #search
              type="text"
              class="form-control search-input"
              placeholder="Search for items..."
              [(ngModel)]="searchText"
              name="search"
              (input)="onSearchChange($event)"
              (focus)="onSearchFocus()"
              (blur)="onSearchBlur()"
              autocomplete="on"
            />
            <button type="submit" class="search-btn" aria-label="Search" (click)="closeSearch(search)">
              <i class="bi bi-search">X</i>
            </button>
          </div>

        </form>

        <!-- Dropdown -->
        <div *ngIf="showDropdown" class="search-dropdown shadow-lg">
          <div *ngIf="loadingSearch" class="text-center py-4">
            <div class="spinner-border text-primary"></div>
          </div>

          <div *ngIf="!loadingSearch && searchResults.length === 0" class="text-center py-4 text-muted">
            <i class="bi bi-search fs-2"></i>
            <p class="mb-0">No results found</p>
          </div>

          <div *ngIf="!loadingSearch && searchResults.length > 0" class="search-results">
            <div
              *ngFor="let product of searchResults; trackBy: trackById"
              class="result-item"
              (click)="selectProduct(product)"
            >
              <img
                [src]="product.photos |ImageUrlPipe"
                alt="{{ product.name }}"
                class="result-image"
                appImageFallback
              />

              <div class="result-details">
                <div class="result-info">
                  <h3 class="result-name">{{ product.name }}</h3>
                  <small >barcode : {{ product.barcode }}</small>
                </div>

                <div class="result-pricing">
                  <div class="price-container">
                    <span class="result-price">{{ product.price }} EGP</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Selected table -->
      <div class="selected-block" *ngIf="selectedRows.length > 0; else emptyState">
        <div class="selected-head">
          <div class="selected-title">
            <i class="bi bi-list-check"></i>
            <span>المختار</span>
          </div>
          <span class="badge-count">{{ selectedRows.length }}</span>
        </div>

        <div class="table-wrap">
          <table class="tp-table">
            <thead>
              <tr>
                <th class="w-price">Image</th>
                <th class="w-price">Name</th>
                <th class="w-price">Price</th>
                <th class="w-value">Prod_Qty</th>
                <th class="w-actions">Remove</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let row of selectedRows; trackBy: trackById">
                <td class="prod-cell">
                  <img class="prod-img" [src]="row.product.photos |ImageUrlPipe" appImageFallback alt="" />
                  
                </td>
                <td>
                    <div class="prod-info">
                        <div class="prod-name">{{ row.product.name }}</div>
                    </div>
                </td>
                <td class="price-cell">
                  {{ row.product.price }} EGP
                </td>

                <td>
                  <input
                    type="number"
                    class="value-input"
                    [value]="row.product.prod_qty"
                    min="0"
                    (input)="updateValue(row, $event)"
                  />
                </td>

                <td class="actions">
                  <button class="trash-btn" type="button" (click)="removeRow(row.product.id)" aria-label="Remove">
                    <i class="bi bi-trash3">X</i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <ng-template #emptyState>
        <div class="empty">
          <i class="bi bi-inboxes"></i>
          <p>اختار منتجات من البحث علشان تظهر هنا.</p>
        </div>
      </ng-template>

    </div>

    <!-- Footer -->
    <div class="tp-modal-footer">
      <button class="btn-cancel" type="button" (click)="onClose()">Cancel</button>
      <button class="btn-save" type="button" [disabled]="selectedRows.length === 0" (click)="onSave()">
        <i class="bi bi-check2-circle"></i>
        Save
      </button>
    </div>

  </div>
</div>
